import {
    NinchatMessages,
    NinchatProperties,
} from '../../../api/types'
import {
    QueueInfo, TransferChatModalProps,
} from './types'
import {
    useChannels, useQueues,
} from '../../../hooks/ninchat'
import {NinchatState} from 'api/types'
import React from 'react'
import TransferChatModalView from './TransferChatView'
import {sendMessage} from 'api/action/sendMessage'
import {toast} from 'components/Toast'
import {transferAudience} from 'api/action/transferAudience'
import {transferConversation} from '../../../actions/modal'
import {useAppDispatch} from '../../../hooks'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

const getTransferQueues = (queues: NinchatProperties.NinchatUserQueues): Array<QueueInfo> => Object.entries(queues).map(([queueId, queue]): QueueInfo => ({
    closed: queue.queue_attrs.closed,
    id: queueId,
    name: queue.queue_attrs.name ?? '',
    suspended: queue.queue_attrs.suspended,
}))

const TransferChatModal = (props: TransferChatModalProps): React.ReactElement => {
    const {
        queueId,
        channelId,
    } = props

    const dispatch = useAppDispatch()

    const {t} = useTranslation()

    const [selectedQueue, setSelectedQueue] = React.useState<string>(queueId)
    const [comment, setComment] = React.useState<string>('')

    const transferQueueIds = useQueues([queueId], false)?.[queueId]?.queue_settings?.transfer_queue_ids ?? []
    const queues = useQueues(transferQueueIds, false)
    const transferQueues = getTransferQueues(queues)
    const audienceChannel = useChannels([channelId])?.[channelId]?.channel_attrs?.audience_id ?? ''

    const isChannelClosed = useSelector(({ninchat}: { ninchat: NinchatState }): boolean => {
        if (!channelId) {
            return true
        }
        return ninchat.user_channels[channelId]?.channel_attrs?.closed === true
    })

    const isChannelSuspended = useSelector(({ninchat}: { ninchat: NinchatState }): boolean => {
        if (!channelId) {
            return true
        }
        return ninchat.user_channels[channelId]?.channel_attrs?.suspended === true
    })

    const closeModal = () => {
        dispatch(transferConversation({show: false}))
    }

    const onSkip = () => {
        closeModal()
    }

    const transfer = () => {
        dispatch(transferAudience({
            audience_id: audienceChannel,
            queue_id: selectedQueue,
            transfer_no_part: true,
        }))
            .unwrap()
            .then(
                () => {
                    toast.success(t('Transfer successful'))
                    closeModal()
                },
                () => {
                    toast.error(t('Error transferring'))
                },
            )
    }

    const onClose = () => {
        if (selectedQueue) {
            if (comment) {
                const data = {transfer_comment: comment}

                dispatch(sendMessage({
                    channel_id: channelId,
                    message_privileged: true,
                    message_type: NinchatMessages.NinchatMessageTypes.NinchatMetadataMessage,
                    payload: [JSON.stringify({data})],
                }))
                    .unwrap()
                    .then(
                        () => {
                            transfer()
                        },
                        () => {
                            toast.error(t('Error sending transfer comment'))
                        },
                    )

                closeModal()
            } else {
                transfer()
            }
        }
    }

    return (
        <TransferChatModalView
            comment={comment}
            isChannelClosed={isChannelClosed}
            isChannelSuspended={isChannelSuspended}
            onCancel={onSkip}
            onClose={onClose}
            queues={transferQueues}
            selectedQueue={selectedQueue}
            setComment={setComment}
            setSelectedQueue={setSelectedQueue}
        />)
}
export default TransferChatModal
